import { Button, Label } from "components/lib";
import React, { useState, forwardRef } from "react";

const CopyStyle = forwardRef(({ items = [], fileName }, ref) => {
  const [copiedIndex, setCopiedIndex] = useState(null);
  const [apiKey, setApiKey] = useState("");

  const handleTextCopy = (inputValue, fileName, index) => {
    navigator.clipboard
      .writeText("") // Clear the clipboard first
      .then(() => {
        // After clearing, proceed with copying the desired text
        return navigator.clipboard.writeText(
          "https://gateway.mapmetrics-atlas.net/styles/?fileName=" +
            fileName +
            "&token=" +
            inputValue
        );
      })
      .then(() => {
        setCopiedIndex(index);
        setTimeout(() => setCopiedIndex(null), 2000); // Reset after 2 seconds
      })
      .catch((err) => {
        console.error("Failed to copy:", err);
      });
  };

  return (
    <div className="space-y-8">
      {items.map((item, index) => (
        <div key={index} className="flex items-center">
          {item.text && (
            <Label className="w-1/3 text-[#FF8F6B] text-[14px] font-semibold">
              {item.text}
            </Label>
          )}
          <div className="relative w-full">
            <input
              type="text"
              className="bg-[#F7F7F8] h-[42px] rounded-[10px] px-2 max-w-full focus:outline-none text-primary text-opacity-20 w-full"
              value={apiKey}
              onChange={(ev) => setApiKey(ev.target.value)}
              placeholder="Enter your Key"
            />
            {item.text === "Download" ? (
              <>
                <p className="text-black text-[12px] mt-3 absolute bottom-[-25px]">
                  Download style sheet JSON
                </p>
                <Button
                  icon={`download`}
                  className={`h-[42px] w-[55px] top-0 rounded-[10px] absolute right-0 bg-[#605BFF] text-white`}
                  variant="primary"
                />
              </>
            ) : (
              <div className="absolute top-0 right-0 group">
                <Button
                  icon={`${copiedIndex === index ? "copy-check" : "copy"}`}
                  className={`h-[42px] w-[55px] rounded-[10px]  bg-[#605BFF] text-white ${
                    copiedIndex === index ? "bg-[#00147E]" : ""
                  }`}
                  variant="primary"
                  onClick={() => {
                    handleTextCopy(apiKey, fileName, index);
                  }}
                />
                {copiedIndex === index && (
                  <div
                    className="absolute bottom-full left-1/2 
                       transform -translate-x-1/2 mb-2 
                       w-max px-2 py-1 text-sm text-white
                       bg-gray-700 rounded shadow-lg 
                       opacity-0 group-hover:opacity-100"
                  >
                    Copied
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
});

CopyStyle.displayName = "CopyStyle";

export { CopyStyle };
